import React, {Component} from "react"
import TextField from "@material-ui/core/TextField";
import _ from 'lodash'
import './BusinessSettings.scss'
import Button from "@material-ui/core/Button";
import GenericAutosuggest from "../GenericAutosuggest/GenericAutosuggest";
import Orders from "../Orders/Orders";
import {OnOffSwitch} from "../OnOffSwitch/OnOffSwitch";
import SettingsConfig from "./SettingsConfig";
import createClone from "rfdc";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import Select from "@material-ui/core/Select/Select";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import FormControl from "@material-ui/core/FormControl/FormControl";

const rfdcClone = createClone();

export default class BusinessSettings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            successDialogOpen: false,
            settings: {
                sla: 0,
                urgentSla: 0,
                deliveryDurationSla: 0,
                featureCoefficients: {},
                dailyLimit: 0
            }
        };

        if (props.settings) {
            this.state.settings = props.settings;
            this.settingsConfig = new SettingsConfig(props.settings, {withIdInput: this.props.withIdInput});
        }

        this.handleStringSettingsChange = this.handleStringSettingsChange.bind(this);
        this.handleTimeSettingsChange = this.handleTimeSettingsChange.bind(this);
        this.handleNumberSettingsChange = this.handleNumberSettingsChange.bind(this);
        this.handleToggleSettingsChange = this.handleToggleSettingsChange.bind(this);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.settingsConfig.setOptions({withIdInput: nextProps.withIdInput});
        this.settingsConfig.setSettings(nextProps.settings);
        this.setState({
            settings: nextProps.settings
        });
    }

    handleStringSettingsChange(settingName, value) {
        const settings = rfdcClone(this.state.settings);
        _.set(settings, settingName, value ? value : null);

        this.settingsConfig.setSettings(settings);
        this.setState({settings});

        if (this.props.onChange)
            this.props.onChange(settings);
    }

    handleTimeSettingsChange(settingName, value) {
        const settings = rfdcClone(this.state.settings);
        _.set(settings, settingName, value ? value : null);

        this.settingsConfig.setSettings(settings);
        this.setState({settings});

        if (this.props.onChange)
            this.props.onChange(settings);
    }

    handleNumberSettingsChange(settingName, value) {
        const settings = rfdcClone(this.state.settings);
        _.set(settings, settingName, value ? Number(value) : null);

        this.settingsConfig.setSettings(settings);
        this.setState({settings});

        if (this.props.onChange)
            this.props.onChange(settings);
    }

    handleToggleSettingsChange(settingName) {
        const settings = rfdcClone(this.state.settings);
        _.set(settings, settingName, !_.get(this.state.settings, settingName));

        this.settingsConfig.setSettings(settings);
        this.setState({settings});

        if (this.props.onChange)
            this.props.onChange(settings);
    }

    onAddressChange(address) {
        this.setState({
            writtenAddress: address.label
        });
    }

    onAddressSelected(address) {
        if (address) {
            const settings = rfdcClone(this.state.settings);
            settings.address = address.label;
            settings.placeId = address.placeId;

            this.settingsConfig.setSettings(settings);
            this.setState({
                writtenAddress: address.label,
                settings
            });

            if (this.props.onChange)
                this.props.onChange(settings);
        }
    }

    renderSettingInput(settingConfig) {
        const type = settingConfig.type;

        if ("condition" in settingConfig && !settingConfig.condition)
            return false;

        if (type === "number")
            return this.renderSimpleInput(settingConfig, this.handleNumberSettingsChange);
        if (type === "text")
            return this.renderSimpleInput(settingConfig, this.handleStringSettingsChange);
        if (type === "time")
            return this.renderSimpleInput(settingConfig, this.handleTimeSettingsChange);
        if (type === "toggle")
            return this.renderToggleInput(settingConfig, this.handleToggleSettingsChange);
        if (type === "menu")
            return this.renderMenuInput(settingConfig, this.handleStringSettingsChange);
        if (type === "address")
            return this.renderAddressInput(settingConfig)
        if (type === "button")
            return this.renderButtonInput(settingConfig)
    }

    renderSimpleInput(settingConfig, onChangeFunction) {
        let value = _.get(this.state.settings, settingConfig.name, '');

        if (value === undefined || value === null)
            value = "";

        return (
            <TextField
                key={settingConfig.name}
                label={settingConfig.displayName}
                onChange={(event) => onChangeFunction(settingConfig.name, event.target.value)}
                type={settingConfig.type || "text"}
                InputLabelProps={{
                    shrink: true,
                }}
                error={settingConfig.error}
                value={value}
                margin="normal"
            />
        )
    }

    renderMenuInput(settingConfig, onChangeFunction) {
        let value = _.get(this.state.settings, settingConfig.name, '');

        if (value === undefined || value === null)
            value = "";

        return (
            <FormControl key={`menu-${settingConfig.name}`} margin="normal">
                <InputLabel id={`business-setting-label-${settingConfig.name}`} className="menu-label">
                    {settingConfig.displayName}
                </InputLabel>
                <Select
                    labelId={`business-setting-label-${settingConfig.name}`}
                    value={value}
                    onChange={(event) => onChangeFunction(settingConfig.name, event.target.value)}>
                    {
                        settingConfig.options.map(menuOption => (
                            <MenuItem key={`menu-item-${settingConfig.name}-${menuOption.value}`}
                                      value={menuOption.value}>{menuOption.displayName}</MenuItem>
                        ))
                    }
                </Select>
            </FormControl>
        );
    }

    renderAddressInput(settingConfig) {
        return (
            <div className="address-autosuggest" key={settingConfig.name}>
                <GenericAutosuggest label={settingConfig.displayName}
                                    placeholder={settingConfig.placeholder}
                                    fetchPredictions={address => Orders.fetchPredictions(address)}
                                    value={this.state.writtenAddress !== undefined ? this.state.writtenAddress : this.state.settings.address}
                                    onChange={this.onAddressChange.bind(this)}
                                    onSelect={this.onAddressSelected.bind(this)}/>
            </div>
        )
    }

    renderButtonInput(settingConfig) {
        return (
            <Button variant="contained"
                    color="secondary"
                    onClick={() => {
                        if (settingConfig.onClick)
                            settingConfig.onClick();
                    }}>
                {settingConfig.displayName}
            </Button>
        );
    }

    renderToggleInput(settingConfig, onChangeFunction) {
        return (
            <div key={settingConfig.name}>
                <label className="switch-label">
                    {settingConfig.displayName}
                </label>
                <OnOffSwitch
                    checked={!!_.get(this.state.settings, settingConfig.name)}
                    onChange={() => onChangeFunction(settingConfig.name)}
                />
            </div>
        )
    }

    render() {
        const {settingsConfig, advancedSettingsConfig} = this.settingsConfig.getSettingsConfig();

        return (
            <div className="settings-dialog-container">
                <div className="settings-container scrollbar" style={{height: this.props.settingsHeight}}>
                    {settingsConfig.map(settingConfig => {
                        return this.renderSettingInput(settingConfig)
                    })}
                    {!this.props.advancedSettings ? false : advancedSettingsConfig.map(settingConfig => {
                        return this.renderSettingInput(settingConfig)
                    })}
                </div>
                {!this.props.withSaveButton ? false :
                    <div className="save-business-container">
                        <Button disabled={this.settingsConfig.anyErrors()}
                                className="save-business"
                                variant="contained"
                                color="primary"
                                onClick={() => this.props.onSave(this.state.settings)}>
                            שמור
                        </Button>
                    </div>
                }
            </div>
        )
    }
}